import { ReactNode } from 'react';

import TabTitle from '../components/TabTitle/TabTitle';

interface IRouteWithTitle {
  title: string;
  children: ReactNode;
}

const RouteWithTitle = ({ title, children }: IRouteWithTitle) => (
  <>
    <TabTitle title={title} />
    {children}
  </>
);

export default RouteWithTitle;
